import { type Application, SegmentAnalytics, startAnalytics, track } from '@betterment/js-runtime';
import { type TestTrack as _TestTrack, initialize } from '@betterment-oss/test-track';

import type { Schema } from './schema.generated';

export type TestTrack = _TestTrack<Schema>;

/**
 * IMPORTANT: This function should only be called once.
 */
export function startTestTrack(): Promise<TestTrack> {
  const testTrack = initialize<Schema>({
    client: {
      appName: 'b4b',
      appVersion: '0.0.0',
      buildTimestamp: import.meta.env.TT_BUILD_TIMESTAMP as string,
    },
    analytics: {
      trackAssignment(_visitorId, assignment) {
        track('SplitAssigned', {
          splitName: assignment.splitName,
          splitVariant: assignment.variant ?? '',
          splitContext: assignment.context ?? undefined,
        });
      },
      alias: () => {},
      identify: () => {},
    },
  });

  const isSegmentInitialized = !!(window.analytics as SegmentAnalytics | undefined);

  if (isSegmentInitialized) {
    startAnalytics(testTrack.visitorId, 'BettermentForBusiness' as Application, { client: 'Web' });
  }

  /**
   * This looks a bit silly. Why would we return a promise?
   *
   * In the future, we'll need to use `load()` to initialize TestTrack, which is async. Using
   * a promise now will prevent that change from becoming more complex in the future.
   */
  return Promise.resolve(testTrack);
}
